import { ArrowRightOutlined } from "@ant-design/icons"
import { Flex, Typography, theme } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { CardComponent } from "../../../../components/Card/CardComponent.tsx"
import { STORY_WORKFLOW_STAGES } from "../../content/product-story.ts"

const { Text } = Typography

export const ConnectedWorkflowDiagram = () => {
  const { t } = useTranslation()
  const { token } = theme.useToken()
  const [selectedId, setSelectedId] = useState(STORY_WORKFLOW_STAGES[0].id)
  const selected =
    STORY_WORKFLOW_STAGES.find((stage) => stage.id === selectedId) ??
    STORY_WORKFLOW_STAGES[0]

  return (
    <Flex vertical gap={20}>
      <Flex wrap align="center" justify="center" gap={6}>
        {STORY_WORKFLOW_STAGES.map((stage, index) => {
          const active = stage.id === selectedId
          return (
            <React.Fragment key={stage.id}>
              <button
                type="button"
                aria-pressed={active}
                onClick={() => setSelectedId(stage.id)}
                className="rounded-full px-3 py-1.5 text-sm font-semibold transition-colors cursor-pointer"
                style={
                  active
                    ? { background: token.colorPrimary, color: "#fff" }
                    : {
                        background: token.colorPrimaryBg,
                        color: token.colorPrimary
                      }
                }
              >
                {t(stage.titleKey)}
              </button>
              {index < STORY_WORKFLOW_STAGES.length - 1 && (
                <ArrowRightOutlined className="text-gray-300" />
              )}
            </React.Fragment>
          )
        })}
      </Flex>

      <CardComponent>
        <Flex vertical gap={4}>
          <Text strong className="text-base">
            {t(selected.titleKey)}
          </Text>
          <Text type="secondary">{t(selected.descriptionKey)}</Text>
        </Flex>
      </CardComponent>
    </Flex>
  )
}
